module.exports = __webpack_public_path__ + "img/oddvega-logo-new.34865268.png";